import * as React from "react";
import Input from "./Input";

interface Props {
  value: string;
  name: string;
  innerRef?: React.Ref<any>;
  skipFirstInput: boolean;
  validate: boolean;
}

class PhoneInput extends React.Component<Props> {
  render() {
    return (
      <Input
        value={this.props.value}
        placeholder="Mobilnummer"
        required={this.props.validate ?? true}
        type="tel"
        name={this.props.name}
        validations={{
          matchRegexp: /^\+?[1-9]\d{1,14}$|^((07){1}\d{8})$/,
        }}
        validationError="Använd 10 siffror för mobilnummer"
        adjustValue={this.adjustPhone}
        skipFirstInput={this.props.skipFirstInput}
        ref={this.props.innerRef}
      />
    );
  }

  adjustPhone = (phone: string): string => {
    // replace +46 with 0
    phone = phone.replace(/^(\+)?46/, "0");
    // replace all non digits exept for leading +
    phone = phone.replace(/(^\+)|[^0-9]/g, "$1");
    // add leading 0 if nine digits not starting with 0
    if (
      phone &&
      phone.length == 9 &&
      !phone.startsWith("0") &&
      !phone.startsWith("+")
    ) {
      return "0" + phone;
    }

    return phone;
  };
}

export default React.forwardRef((props: Props, ref) => (
  <PhoneInput innerRef={ref} {...props} />
));
